import type { UploadFile } from '../../useRepositoryDropzone';

export function findUploadFile(uploadFiles: UploadFile[], fileId: string): UploadFile | undefined {
  return uploadFiles.find(f => f.id === fileId);
}
